import React from "react";
import { useTranslation } from "react-i18next";
import Accordion from "../../components/ui/Accordion";
import AppButton from "../../components/ui/AppButton";
import { getGroupIcon, getGroupLabel, getPermissionLabel, methodToActionKey } from "../../utils/authorityLabels";

const UMAuthorityPermissionMatrix = ({
  groupedCatalog,
  isGranted,
  loading,
  togglingKey,
  onToggle,
  grantsCount = 0,
  resetting = false,
  onResetAll,
}) => {
  const { t } = useTranslation(["staff", "common"]);

  return (
    <div className="card border-0 shadow-sm mb-3">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="fw-bold mb-0">{t("staff:detail.permissions.title")}</h6>
          {grantsCount > 0 && onResetAll && (
            <AppButton
              variant="danger"
              className="btn-sm"
              disabled={loading || resetting}
              onClick={onResetAll}
            >
              {resetting ? (
                <span className="spinner-border spinner-border-sm me-1" role="status"></span>
              ) : (
                <i className="fas fa-undo me-1"></i>
              )}
              {t("staff:detail.permissions.resetAll")}
            </AppButton>
          )}
        </div>

        {loading ? (
          <div className="text-center py-3">
            <div className="spinner-border spinner-border-sm text-primary" role="status"></div>
          </div>
        ) : groupedCatalog.length === 0 ? (
          <p className="text-muted mb-0">{t("staff:detail.permissions.empty")}</p>
        ) : (
          <div className="authority-editor-scroll" style={{ overflowY: "auto" }}>
            <Accordion>
              {groupedCatalog.map(([groupId, entries]) => {
                const grantedCount = entries.filter(isGranted).length;
                return (
                  <Accordion.Item
                    key={groupId}
                    icon={getGroupIcon(groupId)}
                    title={getGroupLabel(t, groupId)}
                    defaultOpen={groupedCatalog.length === 1}
                    meta={
                      <span className="badge bg-light text-dark border me-2">
                        {t("staff:detail.permissions.selectedCount", { selected: grantedCount, total: entries.length })}
                      </span>
                    }
                  >
                    <div className="row g-2">
                      {entries.map((entry) => {
                        const key = `${entry.httpMethod} ${entry.pathTemplate}`;
                        const actionKey = methodToActionKey(entry.httpMethod);
                        return (
                          <div key={key} className="col-md-6">
                            <div className="form-check d-flex align-items-center">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={key}
                                checked={isGranted(entry)}
                                disabled={togglingKey === key}
                                onChange={() => onToggle(entry)}
                              />
                              <label className="form-check-label ms-1 d-flex align-items-center" htmlFor={key}>
                                <span className={`badge action-badge-${actionKey} me-2`}>
                                  {t(`staff:actions.${actionKey}`)}
                                </span>
                                {getPermissionLabel(t, entry)}
                              </label>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </Accordion.Item>
                );
              })}
            </Accordion>
          </div>
        )}
      </div>
    </div>
  );
};

export default UMAuthorityPermissionMatrix;
